export const CONSUMER_INIT_STATE = {
    wizardStep: -2,
    userRequestId: "init",
    addressLine1: "", addressLine2: "", city: "", state: "FL", zip: "", county: "",
    isAddressStandardized : false,
    coverageStartDate: new Date(),
    coverageAmount: 100000,
    insuranceReason: undefined,
    currentInsurer: undefined,
    propertyOccupiedBy: undefined,
    propertyUsage: undefined,

    propertyType: undefined,
    constructionType: undefined,
    yearBuilt: undefined,
    roof: "none",
    electrical: "none",
    plumbing: "none",
    squareFootage: undefined,

    numOfClaims: "-100",
    lossType1: "none",
    claimStatus1: "none",
    lossType2: "none",
    claimStatus2: "none",
    lossType3: "none",
    claimStatus3: "none",
    lossType4: "none",
    claimStatus4: "none",
    lossType5: "none",
    claimStatus5: "none",
    hasOnsitePool: false,
    isLocated1000ftFireHydrant: false,
    is5miFromMannedFireStation: false,
    milesFromSaltWater: "-100",

    ownExoticAnimals: false,
    isDogBreedAmongListed: false,
    isBusinessLocation: false,
    businessType: undefined,
    crtDate: new Date(),
    firstName:undefined,
    lastName: undefined,
    email: undefined,
    mobilePhone: undefined,
    altPhone: undefined,
    referredBy:undefined,
    isMailingSameAsProperty: true,
    mailingAddressLine1: undefined,
    mailingAddressLine2:undefined,
    mailingCity:undefined,
    mailingState:undefined,
    mailingZip:undefined,
    mailingCountry:null,
    userRequestStatus:"INIT",
    mailingCountryInputValue:null,
    grecaptcha:undefined,
    fireStationPrefill: undefined,
    distanceToCoastPrefill: undefined
};

export const AVAILABLE_ACTIONS = {
    INIT: "INIT",
    UPDATE_ADDRESS: "UPDATE_ADDRESS",
    MOVE_NEXT: "MOVE_NEXT",
    ADDRESS_ERROR: "ADDRESS_ERROR",
    UPDATE_PROPERTY_REQUIREMENT: "UPDATE_PROPERTY_REQUIREMENT",
    UPDATE_PROPERTY_DETAILS: "UPDATE_PROPERTY_DETAILS",
    UPDATE_OTHER_DETAILS: "UPDATE_OTHER_DETAILS",
    UPDATE_PETS: "UPDATE_PETS",
    UPDATE_CONTACTINFO : "UPDATE_CONTACTINFO"
}
